import Yup from 'utils/validation';

import { IBusiness } from 'interfaces/IBusinesses';
import { isCEPEmpty, isCNPJEmpty, isValidCNPJ, validDDDs } from 'utils/basicUtils';

export interface TourSeturFormProps {
  selectedId?: string;
  item?: IBusiness | null;
  type?: string;
}

export const states = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

export const toursTypes = [
  { label: 'Agência de Viagem', value: 'Agência de Viagem' },
  { label: 'Parque Aquático', value: 'Parque Aquático' },
  { label: 'Passeios em Geral', value: 'Passeios em Geral' },
  { label: 'Trilha', value: 'Trilha' },
  { label: 'Turismo Náutico', value: 'Turismo Náutico' },
];

export const touristicExperiencesTypes = [
  { label: 'Aldeias Indígenas', value: 'Aldeias Indígenas' },
  { label: 'Aventura e Natureza', value: 'Aventura e Natureza' },
  { label: 'Avistamento de Aves', value: 'Avistamento de Aves' },
  { label: 'Esportivo', value: 'Esportivo' },
  { label: 'Locais de eventos', value: 'Locais de eventos' },
  { label: 'Gastronomia', value: 'Gastronomia' },
  { label: 'História e Cultura', value: 'História e Cultura' },
  { label: 'Náutico e Aquático', value: 'Náutico e Aquático' },
  { label: 'Religioso', value: 'Religioso' },
  { label: 'Roteiros Noturno', value: 'Roteiros Noturno' },
  { label: 'Rural', value: 'Rural' },
  { label: 'Sol e Praia', value: 'Sol e Praia' },
];

export const toursSeturInitialValues = {
  id: '',
  businessRepresentative: '',
  businessOwner: [''],
  description: '',
  phone: '',
  document: '',
  touristicExperiences: '',
  obs: '',
  facebookLink: '',
  experiences: [],
  googleMapsLink: '',
  instagramLink: '',
  status: '',
  tradeEmail: '',
  tradeName: '',
  youtubeLink: '',
  title: '',
  site: '',
  whatsapp: '',
  image: [],
  userId: 0,
  address_id: 0,
  createdAt: '',
  updatedAt: '',
  deletedAt: '',
  address: {
    id: 0,
    additionalData: '',
    city: '',
    neighborhood: '',
    number: '',
    state: '',
    street: '',
    zipCode: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
  },
  images: [],
  structures: [],
  user: '',
  tour: {
    id: '',
    attractions: '',
    equipments: '',
    businessId: 0,
    createdAt: '',
    updatedAt: '',
    deletedAt: '',
  },
};

export const toursSeturValidationSchema = Yup.object().shape({
  id: Yup.number(),
  description: Yup.string().notRequired(),
  document: Yup.string().notRequired(),
  experiences: Yup.array().notRequired(),
  googleMapsLink: Yup.string().notRequired(),
  tradeEmail: Yup.string().notRequired(),
  tradeName: Yup.string().notRequired(),
  title: Yup.string().notRequired(),
  phone: Yup.string().notRequired(),
  image: Yup.array().notRequired(),
  address: Yup.object().shape({
    id: Yup.number(),
    city: Yup.string().notRequired(),
    neighborhood: Yup.string().notRequired(),
    number: Yup.string().notRequired(),
    state: Yup.string().notRequired(),
    street: Yup.string().notRequired(),
    zipCode: Yup.string().notRequired(),
  }),
  images: Yup.array().notRequired(),
  tour: Yup.object().shape({
    id: Yup.number(),
    attractions: Yup.string().notRequired(),
    equipments: Yup.string(),
  }),
});
